import React, { Component } from 'react'
import SectionWrapper from "../../sectionwrapper.component.jsx";
import { ImageContentSectionContent } from "./ImageContentSectionContent.tsx"


class ImageContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            isPdf: this.props.isPdf || false,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        return (
            <SectionWrapper 
                id={this.state.id} 
                section={this.state.section} 
                onEdit={this.state.onEdit} 
                editable={this.state.editable} 
                variables={this.state.variables}
            >
                <ImageContentSectionContent {...this.state} content={this.state.section.attributes.content}/>
            </SectionWrapper>
        );
    }
}

export default ImageContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/image/section.component.jsx